import bilAPI from "../api";

export const getModules = () => {
  return new Promise((resolve, reject) => {
    try {
      bilAPI
        .get("/core/modules")
        .then((res) => {
          resolve(res.data.results);
        })
        .catch((err) => {
          reject("axios error", err);
        });
    } catch (error) {
      reject("system error", error);
    }
  });
};
